/* ----------------------------------------------------------------------------
   Collection "Load more" with back-navigation restore.
   - Click "Mehr laden": fetch next page, append product cards, no reload.
   - Leaving the page (click a product): remember how many products were loaded
     and the scroll position (per collection + active filters).
   - Coming back: re-load up to that many products and restore the scroll spot.
   Progressive enhancement: the button is a real <a href="?page=N"> for no-JS.
---------------------------------------------------------------------------- */
(function () {
  'use strict';

  function listEl() { return document.querySelector('product-list.product-list'); }
  function btnEl() { return document.querySelector('[data-load-more]'); }
  function wrapEl() { return document.querySelector('[data-load-more-wrap]'); }

  /* sessionStorage key = collection path + active filters (page param stripped) */
  function stateKey() {
    var u = new URL(location.href);
    u.searchParams.delete('page');
    return 'clm:' + u.pathname + '?' + u.searchParams.toString();
  }

  function pageUrl(n) {
    var u = new URL(location.href);
    if (n <= 1) { u.searchParams.delete('page'); } else { u.searchParams.set('page', String(n)); }
    return u.pathname + (u.search ? u.search : '');
  }

  /* Appended cards must not depend on the page-load lazy/reveal observers,
     otherwise their images never load and the cards look blank/white. */
  function prepCard(card) {
    if (card.removeAttribute) { card.removeAttribute('reveal-on-scroll'); }
    var imgs = card.querySelectorAll ? card.querySelectorAll('img') : [];
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].setAttribute('loading', 'eager');
      if (imgs[i].hasAttribute('data-src') && !imgs[i].getAttribute('src')) {
        imgs[i].setAttribute('src', imgs[i].getAttribute('data-src'));
      }
    }
    return card;
  }

  function fetchCards(n) {
    return fetch(pageUrl(n), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var l = doc.querySelector('product-list.product-list');
        if (!l) return [];
        return Array.prototype.slice.call(l.children).map(prepCard);
      });
  }

  /* Count + progress bar */
  function updateProgress() {
    var wrap = wrapEl(), list = listEl();
    if (!wrap || !list) return;
    var total = parseInt(wrap.getAttribute('data-total-items'), 10) || list.children.length;
    var shown = Math.min(list.children.length, total);
    var s = wrap.querySelector('[data-lm-shown]'); if (s) s.textContent = shown;
    var bar = wrap.querySelector('[data-lm-bar]'); if (bar) bar.style.width = (total ? Math.round((shown / total) * 100) : 100) + '%';
  }

  function removeButton() {
    var b = btnEl();
    if (b && b.parentNode) b.parentNode.removeChild(b);
  }

  var loading = false;

  function loadMore() {
    var btn = btnEl(), list = listEl();
    if (loading || !btn || !list) return;
    loading = true;
    btn.classList.add('is-loading');
    var next = parseInt(btn.getAttribute('data-current-page'), 10) + 1;
    var total = parseInt(btn.getAttribute('data-total-pages'), 10);
    fetchCards(next).then(function (cards) {
      cards.forEach(function (c) { list.appendChild(c); });
      btn.setAttribute('data-current-page', String(next));
      updateProgress();
      if (next >= total) { removeButton(); }
    }).catch(function () {}).then(function () {
      loading = false;
      if (btnEl()) btnEl().classList.remove('is-loading');
    });
  }

  function save() {
    var list = listEl();
    if (!list) return;
    try {
      sessionStorage.setItem(stateKey(), JSON.stringify({
        count: list.children.length,
        y: window.scrollY || window.pageYOffset || 0
      }));
    } catch (e) {}
  }

  /* True only when the page was reached via browser Back/Forward
     (e.g. returning from a product), not when navigating in fresh. */
  function isBackForward() {
    try {
      var nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
      if (nav && nav.type) return nav.type === 'back_forward';
      if (performance.navigation) return performance.navigation.type === 2;
    } catch (e) {}
    return false;
  }

  function clearState() {
    try { sessionStorage.removeItem(stateKey()); } catch (e) {}
  }

  function restore() {
    var list = listEl();
    if (!list) return;
    var raw;
    try { raw = sessionStorage.getItem(stateKey()); } catch (e) { return; }
    if (!raw) return;

    /* Fresh visit / reload (e.g. picked the category from the menu) → start
       at the top; discard any stale saved position. */
    if (!isBackForward()) { clearState(); return; }

    var st;
    try { st = JSON.parse(raw); } catch (e) { clearState(); return; }
    clearState();
    if (!st) return;

    /* already have enough (e.g. bfcache kept the DOM) → just restore scroll */
    if (!st.count || list.children.length >= st.count) {
      if (st.y) window.scrollTo(0, st.y);
      return;
    }

    var btn = btnEl();
    var total = btn ? parseInt(btn.getAttribute('data-total-pages'), 10) : 1;
    var page = 1;

    function step() {
      if (list.children.length >= st.count || page >= total) {
        var b = btnEl();
        if (b) { b.setAttribute('data-current-page', String(page)); }
        if (page >= total) { removeButton(); }
        updateProgress();
        if (st.y) window.scrollTo(0, st.y);
        return;
      }
      page++;
      fetchCards(page).then(function (cards) {
        cards.forEach(function (c) { list.appendChild(c); });
        updateProgress();
        step();
      }).catch(function () { updateProgress(); if (st.y) window.scrollTo(0, st.y); });
    }
    step();
  }

  function init() {
    if (!listEl()) return;
    updateProgress();
    restore();
  }

  /* Delegated click — survives filter re-renders that replace the button */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-load-more]');
    if (trigger) { e.preventDefault(); loadMore(); return; }
    var productLink = e.target.closest('a[href*="/products/"]');
    if (productLink && listEl() && listEl().contains(productLink)) { save(); }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
